// import { helpers } from './sites/helpers.js';
// import { example } 		from './sites/components/exapmple.js';
import { counters } 		from './sites/components/counters.js';

window.sites = {
	globals: {},

	init: function () {
		var self = this;

		// example.init();

		counters.init();

		self.hasFix();

		jQuery( '.productItem__tab' ).on( 'click', function( event ){
			event.preventDefault();

			const parent 	= jQuery( this ).parent();
			const key 	= jQuery( this ).attr( 'data-tab' );

			parent.find( '.active' ).removeClass( 'active' );
			parent.find( `[data-tab="${key}"]` ).addClass( 'active' );
		});

		jQuery( '.anthill__main h3, .anthill__main button' ).on( 'click', function( event ){
			event.preventDefault();
			jQuery( this ).closest( '.anthill__main' ).find(".active").removeClass( 'active' );
			jQuery( this ).closest( '.anthill__main' ).find(".active").removeClass( 'active' );
			jQuery( this ).closest("li").toggleClass('active');
		});
	},


	hasFix: function() {
		const headers = document.querySelectorAll('h1, h2, h3, h4, h5, h6');

		headers.forEach(heading => {
			if (heading.querySelector('img')) {
				heading.classList.add('contains-img');
			}
		});


		jQuery( document ).on( "click", ".js-openSearch" , function( event ) {
			jQuery("body").addClass("search-active");
		});

		jQuery( document ).on( "click", ".js-search" , function( event ) {
			if (!jQuery(event.target).closest(".js-search .container").length) {
				jQuery("body").removeClass("search-active");
			}
		});
	
		jQuery(document).keyup(function(e) {
			if(jQuery(".js-search").length) {
				if (e.key === "Escape") {
					jQuery("body").removeClass("search-active");
				}
			}
		});
	},
	onresize() {
		var self = this;
	},

	onscroll(position, previusPosition) {
		var self = this;
	},
};

jQuery(document).ready(function ($) {
	sites.init();
});

window.addEventListener('scroll', function (e) {
	// sites.onscroll();
});

window.addEventListener('resize', function (e) {
	// sites.onresize();
});